/**
 * IMPORTS
 */

import React from 'react';
import { Center, CircularProgress } from '@chakra-ui/react';

/**
 * CORE
 */

function FallbackImage() {
  return (
    <Center h="100%">
      <CircularProgress isIndeterminate color="brand.500" />
    </Center>
  );
}

export default FallbackImage;
